export const SET_TICKETS = 'SET_TICKETS';
export const TICKETS_LOADING = 'TICKETS_LOADING';
export const TICKETS_ERROR = 'TICKETS_ERROR';
export const TICKETS_NOT_FOUND = 'TICKETS_NOT_FOUND';
export const APPEND_PRODUCT_IN_TICKET = 'APPEND_PRODUCT_IN_TICKET';

export const VALIDATE_PRODUCT_BY_MOTIVE_LOADING =
  'VALIDATE_PRODUCT_BY_MOTIVE_LOADING';
export const VALIDATE_PRODUCT_BY_MOTIVE_SUCCESS =
  'VALIDATE_PRODUCT_BY_MOTIVE_SUCCESS';
export const VALIDATE_PRODUCT_BY_MOTIVE_ERROR =
  'VALIDATE_PRODUCT_BY_MOTIVE_ERROR';

export const MAKE_SELF_SERVICE_LOADING = 'MAKE_SELF_SERVICE_LOADING';
export const MAKE_SELF_SERVICE_SUCCESS = 'MAKE_SELF_SERVICE_SUCCESS';
export const MAKE_SELF_SERVICE_ERROR = 'MAKE_SELF_SERVICE_ERROR';

export const OPEN_MODAL_SUCCESS = 'OPEN_MODAL_SUCCESS';
export const CLOSE_MODAL_SUCCESS = 'CLOSE_MODAL_SUCCESS';

export const CREATE_TICKET_NO_PRODUCT_LOADING =
  'CREATE_TICKET_NO_PRODUCT_LOADING';
export const CREATE_TICKET_NO_PRODUCT_SUCCESS =
  'CREATE_TICKET_NO_PRODUCT_SUCCESS';
export const CREATE_TICKET_NO_PRODUCT_ERROR = 'CREATE_TICKET_NO_PRODUCT_ERROR';
